export default __webpack_public_path__ + "static/icon-verified-0d0ddafa754fcbe4ba3812deeecd290c.png";